/**
 * Determines the output texture size for a given shader block
 * @param smartFilter - The smart filter to use
 * @param engine - The engine to use
 * @param textureOptions - The texture options to use
 * @returns - The output texture size
 */
export function GetBlockOutputTextureSize(smartFilter, engine, textureOptions) {
    let outputWidth;
    let outputHeight;
    const renderTargetWrapper = smartFilter.outputBlock.renderTargetWrapper;
    if (renderTargetWrapper) {
        outputWidth = renderTargetWrapper.width;
        outputHeight = renderTargetWrapper.height;
    }
    else {
        outputWidth = engine.getRenderWidth(true);
        outputHeight = engine.getRenderHeight(true);
    }
    return {
        width: Math.floor(outputWidth * textureOptions.ratio),
        height: Math.floor(outputHeight * textureOptions.ratio),
    };
}
//# sourceMappingURL=textureUtils.js.map